//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '../../assets/style/weui.css';
export default {

  components: {

  },
  data() {
    return {

      unitNo:'',
      amount:'',
      userShow:false,
      userCode:'',
      deviceList:[],
      dataSource:this.$cookies.get('dataSource'),
      tel:this.$cookies.get('contactNo'),
      commercialName:this.$cookies.get('commercialName'),
      bindList:[],
    };
  },
  created() {

    this.getBindUser()
  },

  mounted() {



  },
  methods: {
    call(tel){
      window.location.href = 'tel://'+tel
    },
    delQuestion(index){
      const _this=this
      _this.$vux.confirm.show({
        title: '操作提醒',
        content: '是否确认解绑此住户？',
        confirmText:'确认',
        onCancel () {
          console.log('plugin cancel')
        },
        onConfirm () {
          _this.deleteUser(_this.bindList[index].userCode)
        }
      })
    },
    gotoList(){
      this.$router.push('/wx/transList')
    },
    deleteUser: async function(userCode){
      this.bindList=[]
      const _this=this;
      let params = {
        commercialNumber:this.$cookies.get('commercialNo'),
        token:this.$cookies.get('wxToken'),
        userCode:userCode

      };
      console.log(params);
      const response = await this.$api.postjson("/wechat/unbind", params);
      console.log('解绑',response)
      if(response.data.code=='0000') {
        _this.$vux.toast.show({
          text: '解绑成功',
          type: "success",
          time:'3000'
        })
        _this.getBindUser()
      }

      else{
        _this.$vux.toast.show({
          text: response.data.msg,
          type: "warn",
          time:'3000'
        })
      }
    },
    chooseDevice(index){
      let deviceInfo=JSON.stringify(this.deviceList[index])
      this.$router.push({
        name: 'wxPayOrder',
        query: {
          deviceInfo:deviceInfo,
        }
      })
    },
    getBindUser: async function(){
      this.bindList=[]
      const _this=this;
      let params = {
        commercialNumber:this.$cookies.get('commercialNo'),
        token:this.$cookies.get('wxToken'),

      };
      console.log(params);
      const response = await this.$api.postjson("/wechat/queryBind", params);
      console.log('已绑定查询',response)
      if(response.data.code=='0000') {
        _this.bindList=response.data.data
      }

      else{
        _this.$vux.toast.show({
          text: response.data.msg,
          type: "warn",
          time:'3000'
        })
      }

    },
    getUsre(){
      this.getDeviceInfo(this.userCode)

    },
    bindToPay(index){
      this.getDeviceInfo(this.bindList[index].userCode)
    },
    getDeviceInfo: async function(userCode){
      this.deviceList=[]
      const _this=this;
      let params = {
        commercialNumber:this.$cookies.get('commercialNo'),
        token:this.$cookies.get('wxToken'),
        userCode:userCode,
        channelId:''
      };
      console.log(params);
      const response = await this.$api.postjson("/wechat/queryDevice", params);
      console.log('水费查询',response)
      if(response.data.code=='0000'){
        if(response.data.data.length==1){
          let deviceInfo=JSON.stringify(response.data.data[0])
          _this.$router.push({
            name: 'wxPayOrder',
            query: {
              deviceInfo:deviceInfo,
            }
          })
        }
        else if(response.data.data.length>1){
          _this.deviceList=response.data.data
          _this.userShow=true
        }
        else{
          _this.$vux.toast.show({
            text: '暂无数据',
            type: "warn",
            time:'3000'
          })
        }
        /* _this.address=response.data.data.row[0].address
         _this.qf=response.data.data.row[0].qf
         _this.unit_name=response.data.data.row[0].unit_name
         _this.ye=response.data.data.row[0].ye
         _this.yjqf=response.data.data.row[0].yjqf*/
      }
      else{
        _this.$vux.toast.show({
          text: response.data.msg,
          type: "warn",
          time:'3000'
        })
      }
    },

  }
};



// WEBPACK FOOTER //
// ./src/views/wx/home.vue